import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { UiService } from '@services/ui.service';
import { AddressGroupsService } from '@services/address-groups.service';
import { AddressGroup } from '@classes/address-group';

@Injectable()
export class AddressGroupsResolver {
  constructor(
    private addressGroupsSrv: AddressGroupsService,
    private uiSrv: UiService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<AddressGroup[]> {
    this.uiSrv.routeLoadingStateChanged.next(true);
    return this.addressGroupsSrv
      .getList()
      .pipe(tap(() => this.uiSrv.routeLoadingStateChanged.next(false)));
  }
}
